import { render, staticRenderFns } from "./geography.vue?vue&type=template&id=03e6d978&"
import script from "./geography.vue?vue&type=script&lang=js&"
export * from "./geography.vue?vue&type=script&lang=js&"
import style0 from "./geography.vue?vue&type=style&index=0&id=03e6d978&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports